import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getGeoQueryDefinitionAction } from "../actions";
import { getRows, getLoading, getDateFormat } from "../selectors";
import { CLEAR_STATE } from "../actionTypes";
import { getIsExportingGrid } from "@icarius-app/selectors";
import { getLocalizedString } from "@icarius-localization/strings";
import CommonPage from "@icarius-common/commonPage";
import paths from "@icarius-router/paths";
import FormContainer from "./form/formContainer";
import ConfirmationDialog from "./dialogs/confirmationDialog";
import DuplicateDialog from "./dialogs/duplicateDialog";
import CustomIconButton from "@icarius-common/abmComponents/customIconButton";
import useABM from "./useABM";
import MenuItemWithIcon from "@icarius-common/MenuItemWithIcon";
import SearchConcept from "./searchConcept";

const GeoQueryDefinition = ({ handleOpenParameterPage, handleGoBack }) => {
    const dispatch = useDispatch();

    const data = useSelector(getRows);
    const dateFormat = useSelector(getDateFormat);
    const isLoading = useSelector(getLoading);
    const isExportinGrid = useSelector(getIsExportingGrid);

    useEffect(() => {
        dispatch(getGeoQueryDefinitionAction());
        return () => {
            dispatch({ type: CLEAR_STATE });
        };
    }, [dispatch]);

    const {
        deleteDialogIsOpen,
        createEditDialogIsOpen,
        duplicateDialogIsOpen,
        selectedItem,
        handleOpenCreateDialog,
        handleOpenEditDialog,
        handleCloseEditDialog,
        handleOpenDeleteDialog,
        handleCloseDeleteDialog,
        handleOpenDuplicateDialog,
        handleCloseDuplicateDialog,
        handleDelete,
        handleDuplicate,
    } = useABM();

    const goBackItem = () => (
        <CustomIconButton title={getLocalizedString("goBack")} onClick={handleGoBack} type={"goBack"} />
    );

    const addItem = () => (
        <CustomIconButton title={getLocalizedString("create")} onClick={() => handleOpenCreateDialog()} type={"add"} />
    );

    const deleteItem = (gridRef) => (
        <CustomIconButton
            title={getLocalizedString("delete")}
            onClick={() => handleOpenDeleteDialog(gridRef)}
            type={"delete"}
        />
    );

    const editItem = (gridRef) => (
        <CustomIconButton
            title={getLocalizedString("edit")}
            onClick={() => handleOpenEditDialog(gridRef)}
            type={"edit"}
        />
    );

    const duplicateItem = (gridRef) => (
        <CustomIconButton
            title={getLocalizedString("duplicate")}
            onClick={() => handleOpenDuplicateDialog(gridRef)}
            type={"duplicate"}
        />
    );

    const handleRowClick = (row) => {
        handleOpenParameterPage(row.data);
    };

    const helpItems = [
        <MenuItemWithIcon
            key={"a"}
            value={"/resources/ICARIUS - Iconografia KPI - Iconos.pdf"}
            text={getLocalizedString("kpiIconographyIcons")}
            type={"file"}
        />,
        <MenuItemWithIcon
            key={"b"}
            value={"/resources/ICARIUS - Definición de gestión (Consultas-GeoAnálisis-KPI).pdf"}
            text={getLocalizedString("managementDefinitionConsultationsGeoAnalysisKPI")}
            type={"file"}
        />,
    ];

    const searchItem = (ref) => <SearchConcept gridRef={ref} data={data} />;

    return (
        <>
            {createEditDialogIsOpen ? (
                <FormContainer isLoading={isLoading} data={selectedItem} handleClose={handleCloseEditDialog} />
            ) : (
                <CommonPage
                    helpItems={helpItems}
                    columnDefPage={paths.geoQuery}
                    title={getLocalizedString("geoanalysisQueriesDefinition")}
                    gridTitle={getLocalizedString("geoAnalysisQueryDefinition")}
                    menuItems={[goBackItem, searchItem, addItem, editItem, deleteItem, duplicateItem]}
                    rowData={data}
                    dateFormat={dateFormat}
                    isLoading={isExportinGrid || isLoading}
                    handleRowClick={handleRowClick}
                    hasExpand
                    hasHelp
                >
                    {deleteDialogIsOpen && !isLoading && (
                        <ConfirmationDialog
                            open={deleteDialogIsOpen}
                            title={getLocalizedString("atention")}
                            text={getLocalizedString("areYouSureYouWantToDeleteGeoAnalysisQueryDefinition")}
                            handleConfirm={handleDelete}
                            handleClose={handleCloseDeleteDialog}
                        />
                    )}
                    {duplicateDialogIsOpen && !isLoading && (
                        <DuplicateDialog
                            open={duplicateDialogIsOpen}
                            data={selectedItem}
                            handleConfirm={handleDuplicate}
                            handleClose={handleCloseDuplicateDialog}
                        />
                    )}
                </CommonPage>
            )}
        </>
    );
};

export default GeoQueryDefinition;
